module.exports = __webpack_public_path__ + "static/media/0_2020_03_30.b1214d70.jpg";